<template>
    <div>
        <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">
            返回
        </el-button>

        <el-button
            v-if="!this.status"
            type="primary"
            size="mini"
            @click="search.chooseOrgVisible = true; searchCourseData()"
        >
          添加
        </el-button>

        <el-row>
            <el-table v-loading="loading" :data="list" border size="mini" :stripe="true"
                style="width: 100%; margin: 20px 0;">
                <el-table-column prop="course_id" label="ID" align="center" min-width="3%"></el-table-column>
                <el-table-column label="课程图片" align="center" min-width="8%">
                    <template slot-scope="{ row }">
                        <img :src="row.img_url" style="width: 40px;" alt="" />
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="课程标题" align="center" min-width="10%"></el-table-column>

                <el-table-column label="封面" align="center" min-width="15%">
                    <template slot-scope="{ row }">
                      <el-row>
                        <el-col :span="12">
                          <el-upload
                              class="avatar-uploader"
                              :action="ossAction"
                              :show-file-list="false"
                              :http-request="uploadOSSRequest"
                              :before-upload="beforeImageUpload"
                              :data="{relationId:row.id}"
                          >
                            <img style="width: 100px;height: 70px;" v-if="row.cover_image_url" :src="row.cover_image_url" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                        </el-col>
                        <el-col :span="12">
                          <span>图片大小：500kb以内</span>
                          <br>
                          <span>图片尺寸：674x182px</span>
                        </el-col>
                      </el-row>
                    </template>
                </el-table-column>

                <el-table-column label="操作" align="center" min-width="14%">
                    <template slot-scope="{ row }">
                        <el-button type="danger" size="mini" @click="deleteRelationship(row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="query.page"
                    :page-size="query.limit" layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>

      <el-dialog
          title="关联课程"
          :visible.sync="search.chooseOrgVisible"
          :close-on-click-modal="true"
          :before-close="addEditFormOnClose"
          width="75%"
      >
        <el-form :inline="true" :model="search.query">
          <!-- 模糊查询 -->
          <el-form-item>
            <el-input
                v-model="search.query.title"
                placeholder="请输入课程标题"
                clearable
            />
          </el-form-item>
          <!--查询按钮-->
          <el-form-item>
            <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchCourseData()"
                :loading="search.listLoading1"
            >搜索</el-button
            >
          </el-form-item>
        </el-form>

        <!--列表-->
        <el-table
            border
            :data="search.result.data"
            highlight-current-row
            v-loading="search.listLoading1"
            style="..."
        >
          <el-table-column
              prop="id"
              label="课程ID"
              align="center"
          ></el-table-column>
          <el-table-column label="图片" align="center">
            <template slot-scope="{ row }">
              <img :src="row.img_url" style="width: 40px" alt="" />
            </template>
          </el-table-column>

          <el-table-column
              prop="title"
              label="标题"
              align="center"
          ></el-table-column>

          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="{ row }">
              <el-button
                  type="primary"
                  size="small"
                  @click="addAdvancePlanCourse(row.id)"
              >
                添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            @current-change="searchPageCourseData"
            :current-page.sync="search.query.page"
            :page-size="search.query.limit"
            layout="total, prev, pager, next, jumper"
            :total="search.result.total"
        >
        </el-pagination>
      </el-dialog>
    </div>


</template>

<script>
import {
    advancePlanCourseList,
    advancePlanCourseCoverImage,
    advancePlanRelationshipDel,
    advancePlanAllCourseList,
    addAdvancePlanCourse,
} from "@/api/course";

import {
  uploadOSSRequest,
  getAliyunOssToken,
} from "@/api/common";
import {Message} from "element-ui";
export default {
    data: function () {
        return {
            ossAction: "",
            list: [],
            loading: false,
            total: 0,
            status:1,
            query: {
                pid:this.$route.query.id,
                page: 1,
                limit: 10,
            },

            info: {
                id: 0,
                title: "",
                intro: ""
            },
            dialogVisible: false,
            search:{
              query:{
                pid:this.$route.query.id,
                page:1,
                limit:10,
                title: ''
              },
              result:{
                total: 0,
                data: [],
              },

              chooseOrgVisible:false,
              listLoading1 : false
            },
          uploadImageData:{
              id:0,
              cover_image_url :''
          }

        };
    },
    created: function () {
        this.getList();
    },
    methods: {
        getList () {
            this.loading = true;
            advancePlanCourseList(this.query).then((response) => {
                this.list = response.data.list;
                this.total = response.data.total;
                this.status = response.data.status
                this.loading = false;
            });
        },

      // 查询课程方法
      searchCourseData() {
        this.search.listLoading1 = true;
        this.search.result = {
          total: 0,
          data: [],
        };
        advancePlanAllCourseList(this.search.query).then((response) => {
          this.search.result.data = response.data.list;
          this.search.result.total = response.data.total;
          this.loading = false;
          this.search.listLoading1 = false;
        });
      },

      searchPageCourseData() {
        this.search.listLoading1 = true;
        advancePlanAllCourseList(this.search.query).then((response) => {
          this.search.result.data = response.data.list;
          this.search.result.total = response.data.total;
          this.loading = false;
          this.search.listLoading1 = false;
        });
      },

      // 弹窗关闭
      addEditFormOnClose() {
        this.search.query.title = "";
        this.search.result = [];
        this.search.chooseOrgVisible = false;
      },
      //添加关联课程
      addAdvancePlanCourse(course_id) {
        addAdvancePlanCourse({
          pid: this.$route.query.id,
          course_id: course_id,
        }).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.addEditFormOnClose();
            this.getList();
          } else {
            /*this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });*/
          }
        });
      },

      deleteRelationship(id){
        this.$confirm("确定执行删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          advancePlanRelationshipDel({
            id: id,
          }).then((response) => {
            if (response.status == 2000) {
              this.query.page = 1;
              this.getList();
              this.$message({
                showClose: true,
                message: "删除成功",
                type: "success",
              });
            } else {
              /*this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });*/
            }
          });
        });
      },

      beforeImageUpload(file) {
        if (file.type.split("/")[0] != "image") {
          Message({
            message: '请上传图片',
            type: 'error',
            duration: 5 * 1000
          });
          return false;
        }
        const isLt1M = file.size / 1024 / 1024 < 1;
        if (!isLt1M) {
          Message({
            message: '上传图片大小不能超过 1MB!',
            type: 'error',
            duration: 3 * 1000
          });
          return false;
        }
        return isLt1M;
      },

      uploadOSSRequest(file) {
        this.uploadImageData.id = file.data.relationId;
        getAliyunOssToken({ dir: "" }).then((res) => {
          uploadOSSRequest(file.file, res.data).then((fileUrl) => {
            this.loading = true;
            this.uploadImageData.cover_image_url = fileUrl;
            advancePlanCourseCoverImage(this.uploadImageData).then(()=>{
              this.list.forEach(function (item){
                if(item.id == file.data.relationId){
                  item.cover_image_url = fileUrl;
                }
              })
              this.loading = false;
              /*this.getList();*/
            })
          });
        });
      },
      setRelationShipId(id){
          console.log(id)
          this.uploadImageData.id = id;
      }

    },
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 335px;
  height: 143px;
  display: block;
  background: #D8D8D8;
  border-radius: 6px;
}
.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}
</style>